import { NoteDetailFormValue } from '../../../coaching-note/note-detail-form-value.model';
import { TranscriptQuote } from '../../../teams-call';
import { User } from '../../../user/user.model';

import { createNote } from './create-note.function';

export function createNoteFromQuotes(
    selectedQuotes: TranscriptQuote[],
    user: User,
): NoteDetailFormValue {
    const text = (selectedQuotes ?? []).reduce((p, c) => {
        return `${p}${c.quote ?? ''}<br/>`;
    }, '');

    return createNote(text, user);
}
